import script from "./Contacto.vue?vue&type=script&setup=true&lang=js"
export * from "./Contacto.vue?vue&type=script&setup=true&lang=js"

import "./Contacto.vue?vue&type=style&index=0&id=7a955f06&scoped=true&lang=scss"
import "./Contacto.vue?vue&type=style&index=1&id=7a955f06&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a955f06"]])

export default __exports__